var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5302_36010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1581 17.5849H19.1565L17.7681 5.92368C17.7496 5.76734 17.617 5.64961 17.4596 5.64961H14.0414V4.71738C14.0414 2.48633 12.2328 0.677734 10.0018 0.677734C7.7707 0.677734 5.9621 2.48633 5.9621 4.71738V5.64961H2.54394C2.38651 5.64961 2.25394 5.76734 2.23538 5.92368L0.84698 17.5849C0.745562 18.437 1.35407 19.2099 2.20617 19.3114C2.26723 19.3186 2.32864 19.3223 2.39013 19.3223H17.6149C18.473 19.3225 19.1688 18.627 19.169 17.7689C19.169 17.7074 19.1653 17.646 19.1581 17.5849ZM6.58359 4.71738C6.58359 2.82958 8.11395 1.29922 10.0018 1.29922C11.8895 1.29922 13.4199 2.82958 13.4199 4.71738V5.64961H6.58359V4.71738ZM18.3107 18.3875C18.1341 18.5864 17.8809 18.7004 17.6149 18.7008H2.39013C1.87526 18.7009 1.45778 18.2837 1.45759 17.7689C1.45759 17.732 1.45976 17.6952 1.46411 17.6585L2.81988 6.27109H5.9621V8.44629C5.9621 8.61789 6.10124 8.75703 6.27285 8.75703C6.44445 8.75703 6.58359 8.61789 6.58359 8.44629V6.27109H13.4199V8.44629C13.4199 8.61789 13.559 8.75703 13.7307 8.75703C13.9023 8.75703 14.0414 8.61789 14.0414 8.44629V6.27109H17.1836L18.5394 17.6585C18.5708 17.9231 18.4876 18.1884 18.3107 18.3875Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.55
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5302_36010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.53715031b0d61d0c2c23a7401dd8680e.svg";
export { ForwardRef as ReactComponent };